import { ERROR_MESSSAGE } from "../../config";

export const actions = {
  /**
   * Verify if the email actually belongs to a user.
   * If it belongs to a user, set the details related to the user
   * @param {String} email
   */
  async verifyEmail(context, email) {
    /**
     * Step 1: Send verify request
     *
     * Response format
     * {
     *   code: 200, // The response code
     *   details: {
     *      question: "Who is your favorite artist?", // Question number 1
     *      token: "3899982836a68da094f860410f84ff993f5", // Token associated with the request
     *      insurance: {
     *          businessName: "Greater Valley", // To be shown to the user
     *          insuranceCoID: 2833,
     *          shortName: "Greater Valley"
     *      }[2] // Insurance company question options. 2 options are there
     *   }
     * }
     */
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "forgot/verify",
        method: "POST",
        data: {
          email
        }
      },
      {
        root: true
      }
    );

    // Step 2: Check if details is in json
    if (
      !("details" in json) ||
      !("id" in json.details) ||
      !("question" in json.details) ||
      !("token" in json.details) ||
      !("insurance" in json.details)
    ) {
      context.commit("setWrongEmail", true);
      return false;
    }

    // Step 3: Set the userId
    context.commit("setUserId", parseInt(json.details.id));

    // Step 4: Set the question
    context.commit("setQuestion", json.details.question);

    // Step 5: Set insurance question
    context.commit("setInsuranceQuestions", json.details.insurance);

    // Step 6: Set the token
    context.commit("setToken", json.details.token);
  },

  /**
   * Match the user's answer to correct answers.
   * If it doesn't match, show error message
   * @param {Object} context
   * @param {Object} answers
   */
  async matchAnswer(context, answers) {
    // Step 1: Add the userId and token
    answers.id = context.getters.getUserId;
    answers.token = context.getters.getToken;

    // Step 2: Send the verify request
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "forgot/match_answers",
        method: "POST",
        data: answers
      },
      {
        root: true
      }
    );

    // Step 3: Clear state
    context.commit("clear");

    // Step 4: Show the message
    if (json.code === 200) {
      context.commit("setBottomMessage", ERROR_MESSSAGE.forgotPasswordSuccess, {
        root: true
      });
    } else if (json.code === 401) {
      context.commit("setBottomMessage", ERROR_MESSSAGE.forgotPasswordInvalid, {
        root: true
      });
    } else {
      context.commit(
        "setBottomMessage",
        ERROR_MESSSAGE.forgotPasswordUnSuccess,
        {
          root: true
        }
      );
    }
  },

  /**
   * Verify if the reset token is correct
   * @param {Object} context
   */
  async verifyResetToken(context) {
    // Step 1: Get the reset token
    const resetToken = context.getters.getResetToken;

    // Step 2: Send verification request
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: `forgot/verify_reset_token/${resetToken}`,
        method: "GET"
      },
      {
        root: true
      }
    );

    // Step 3: Set reset token verified
    if (json.code === 200) {
      context.commit("setResetTokenVerified", 1);
    } else {
      context.commit("setResetTokenVerified", -1);
    }
  },

  /**
   * Send reset password request
   * @param {Object} context
   * @param {Object} data
   */
  async resetPassword(context, data) {
    // Step 1: Get the reset token
    data.token = context.getters.getResetToken;

    // Step 2: Send the verify request
    const json = await context.dispatch(
      "makeAuthRequest",
      {
        url: "forgot/reset_password",
        method: "POST",
        data: data
      },
      {
        root: true
      }
    );

    // Step 3: Clear state
    if (json.code === 200) {
      context.commit("clear");
      context.commit(
        "setBottomMessage",
        ERROR_MESSSAGE.passwordResetSuccessful,
        { root: true }
      );
      return;
    }
    context.dispatch("globalMessagePopup", json.message, { root: true });
  }
};
